__turbopack_context__.v({
  "addressName": "g89qjW_addressName",
  "buttonsWrapper": "g89qjW_buttonsWrapper",
  "icon": "g89qjW_icon",
  "summaryWrapper": "g89qjW_summaryWrapper",
  "triggerWrapper": "g89qjW_triggerWrapper",
});
